import { render, staticRenderFns } from "./subjectAnalysis.vue?vue&type=template&id=70218b00&scoped=true&"
import script from "./subjectAnalysis.vue?vue&type=script&lang=js&"
export * from "./subjectAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./subjectAnalysis.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./subjectAnalysis.vue?vue&type=style&index=1&id=70218b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70218b00",
  null
  
)

export default component.exports